import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';

const dateFormat = 'DD.MM.';

class WeekEvents extends Component {
  openEvent(e, event) {
    e.preventDefault();
    this.props.changeMapView('OPEN_AND_SHOW', event.EVENT_ID);
  }

  openAndShowEvent(e, event) {
    e.preventDefault();
    this.props.changeMapView('OPEN', event.EVENT_ID);
  }

  render() {
    if (this.props.weekEvents.length > 0) {
      return (
        <div key={this.props.week}>
          <b>Viikko {' '} {this.props.week}</b> {' – '}
          {moment(this.props.yearViewDate).week(this.props.week).startOf('week').format(dateFormat)}{'–'}
          {moment(this.props.yearViewDate).week(this.props.week).endOf('week').format(dateFormat)}
          <hr />
          {this.props.weekEvents.map(event => (
            <div className="listContentWeek" key={event.EVENT_ID}>
              <Col xsHidden md={3} className="weekEventImage">
                <svg width="50" height="50">
                  <circle cx="25" cy="25" r="25" fill="#c4c4c4" />
                </svg>
              </Col>
              <Col xs={12} md={9} className="weekEventContent">
                <Row>
                  {moment(event.START_DATE).format(dateFormat)}
                  {'–'}
                  {moment(event.END_DATE).format(dateFormat)}
                </Row>
                <Row>
                  <b>
                    {event.EVENT_NAME}
                  </b>
                </Row>
                <Row>
                  <a className="listLink" href="/" onClick={e => this.openEvent(e, event)}>Avaa</a>
                  {' | '}
                  <a className="listLink" href="/" onClick={e => this.openAndShowEvent(e, event)}>Näytä kartalla</a>
                </Row>
              </Col>
            </div>
          ))}
          <hr />
        </div>
      );
    }

    return (
      <div />
    );
  }
}

WeekEvents.propTypes = {
  weekEvents: PropTypes.array.isRequired,
  week: PropTypes.number.isRequired,
  yearViewDate: PropTypes.object.isRequired,
  changeMapView: PropTypes.func.isRequired
};

export default WeekEvents;



// WEBPACK FOOTER //
// ./src/components/WeekEvents.jsx